import { render, staticRenderFns } from "./SubscriptionButtons.vue?vue&type=template&id=06d013e7&scoped=true&"
import script from "./SubscriptionButtons.vue?vue&type=script&lang=js&"
export * from "./SubscriptionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d013e7",
  null
  
)

export default component.exports